/* eslint-disable max-len */
import { stripDomain } from 'shared/utils/stripDomain'

import { Providers, ProvidersType } from '../types/configuration'
import allWaysFruits from './imagesForReplace/allWaysFruits.svg'
import biggerBassBonanze from './imagesForReplace/biggerBassBonanze.svg'
import bookOfDead from './imagesForReplace/bookOfDead.svg'
import chillliHeat from './imagesForReplace/chillliHeat.svg'
import crazyTime from './imagesForReplace/crazyTime.svg'
import gatesOfOlympus from './imagesForReplace/gatesOfOlympus.svg'
import hotHotFruit from './imagesForReplace/hotHotFruit.svg'
import sweetBonanzaCandyland from './imagesForReplace/sweetBonanzaCandyland.svg'
import waysDogs from './imagesForReplace/waysDogs.svg'
import wildWest from './imagesForReplace/wildWest.svg'
import wildWildRiches from './imagesForReplace/wildWildRiches.svg'

export const imageReplacementList: Record<string, string> = {
  vs20olympgate_prg: gatesOfOlympus,
  vs20olympgate: gatesOfOlympus, // pragmatic
  vswaysdogs_prg: waysDogs,
  vswaysdogs: waysDogs, // pragmatic
  allways_fruits_original: allWaysFruits,
  bookofdead_png: bookOfDead,
  vs40wildwest_prg: wildWest,
  vs576treasures_prg: wildWildRiches,
  vs12bbb_prg: biggerBassBonanze,
  vs12bbb: biggerBassBonanze, // pragmatic
  vs25chilli_prg: chillliHeat,
  vs25chilli: chillliHeat, // pragmatic
  GatesOfOlympus1: gatesOfOlympus,
  TheDogHouseMegaways1: waysDogs,
  SGHotHotFruit: hotHotFruit,
  WildWestGold: wildWest,
  WildWildRiches: wildWildRiches,
  BiggerBassBonanza: biggerBassBonanze,
  ChilliHeat: chillliHeat,
  'evolution:crazytime': crazyTime,
  'crazytime:pqe3bikvb6ebirul': crazyTime,
  SweetBonanzaCandyland: sweetBonanzaCandyland,
}

export type GetGameCatalogImage = {
  slotId: string
  imageUrl: string
  provider: ProvidersType
  imageDesktop?: string
  platform?: string
}

const PROVIDER_MAP: Record<ProvidersType, string> = {
  [Providers.OUTCOME]: 'outcome',
  [Providers.SOFTGAMING]: 'softgaming',
  [Providers.SOFTSWISS]: 'softswiss',
  [Providers.DIGITAIN]: 'digitain',
  [Providers.DIRECT_PRAGMATIC]: 'pragmatic',
  [Providers.KELT_GAMES]: 'keltgames',
}

export const getGameCatalogImage = ({ slotId, imageUrl, imageDesktop, provider, platform }: GetGameCatalogImage) => {
  if (imageReplacementList[slotId]) {
    return imageReplacementList[slotId]
  }

  const url = platform === 'desktop' ? imageDesktop || imageUrl : imageUrl

  const mappedProvider = PROVIDER_MAP[provider]
  const urlWithoutDomain = stripDomain(url)

  return `/frontend-service/game-images/${mappedProvider}${
    urlWithoutDomain.startsWith('/') ? urlWithoutDomain : `/${urlWithoutDomain}`
  }`
}

export const getSoftswissSlotImage = (slotProvider: string, slotId: string, platform?: string) =>
  getGameCatalogImage({
    imageUrl: `i/s3/${slotProvider}/${slotId.substring(slotId.lastIndexOf(':') + 1)}.png`,
    platform,
    slotId,
    provider: Providers.SOFTSWISS,
  })

export const getOtcSlotImage = (slotId: string, sectionId: string, platform?: 'mobile' | 'desktop') => {
  const slotIdStr = slotId.toLowerCase()
  const sectionIdLower = sectionId.toLowerCase()
  const size = platform === 'desktop' ? '640x480' : '235x235'

  return getGameCatalogImage({
    slotId,
    imageUrl: `${size}/${sectionIdLower}/${slotIdStr}.jpg`,
    provider: Providers.OUTCOME,
  })
}
